// extracted by mini-css-extract-plugin
export default {"contenedor":"texto-devolucion_contenedor__Ck7KG","texto_titulo":"texto-devolucion_texto_titulo__PvIde","texto_monto":"texto-devolucion_texto_monto__wwYQI"};